import {Tag} from "../../utils/types/AiTypes";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import {API_AI_TAG_ENDPOINT} from "../../utils/constants";

export interface TagState {
    tags: Tag[];
    status: "fulfilled" | "pending" | "rejected" | "idle";
}

const initialState: TagState = {
    tags: [],
    status: "idle"
}

export const fetchAllTags = createAsyncThunk(
    "tags/fetchAllTags",
    async (params: {keycloak: Keycloak.KeycloakInstance}): Promise<Tag[]> => {
        const {keycloak} = params;
        const res = await axios.get(`${API_AI_TAG_ENDPOINT}`, {
            headers: {
                "Content-Type": "application/json",
                accept: "application/json",
                Authorization: `Bearer ${keycloak?.token}`,
            },
            withCredentials: true,
        });
        return res.data;
    }
);

export const TagSlice = createSlice({
    name: 'Tags',
    initialState,
    reducers: {
        getTags: (state, action) => {
            state.status = 'fulfilled';
            state.tags = action.payload.data;
        },
        failedToGetTags: (state) => {
            state.status = 'rejected';
            state.tags = [];
        },
        resetTagsState: (state) => {
            state.tags = [];
            state.status = 'idle';
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAllTags.pending, (state) => {
            state.status = "pending";
        })
        builder.addCase(fetchAllTags.fulfilled, (state, action) => {
            state.status = "fulfilled";
            state.tags = action.payload;
        })
        builder.addCase(fetchAllTags.rejected, (state) => {
            state.status = "rejected";
        })
    }
});

export const { getTags, failedToGetTags, resetTagsState} = TagSlice.actions;
export default TagSlice.reducer;
